export class TimelineSetSearchTerm {
  static readonly type = '[ShiftTimelineFilter] Timeline Set SearchTerm';
  constructor(public searchTerm: string) {}
}
